import { useTranslation } from 'react-i18next';
import ImportAccountingDoctorAttendingCsvForm from '@/components/forms/import-accounting-doctor-attending-csv-form/import-accounting-doctor-attending-csv-form';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  ImportAccountingDoctorAttendingCsvModalApi,
  useImportAccountingDoctorAttendingCsvModalViewModel,
} from './import-accounting-doctor-attending-csv-modal.viewmodel';

export const ImportAccountingDoctorAttendingCsvModal = ({
  onSuccess,
  onClose,
  onCancel,
}: ImportAccountingDoctorAttendingCsvModalApi) => {
  const { t } = useTranslation();
  const viewModel = useImportAccountingDoctorAttendingCsvModalViewModel({
    api: {
      onSuccess,
      onClose,
      onCancel,
    },
  });

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) viewModel.api.close();
      }}
    >
      <DialogContent
        className="sm:max-w-2xl"
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {t('import-accounting-doctor-attending-csv-modal.title')}
          </DialogTitle>
          <DialogDescription>
            {t('import-accounting-doctor-attending-csv-modal.description')}
          </DialogDescription>
        </DialogHeader>

        <ImportAccountingDoctorAttendingCsvForm form={viewModel.form} />

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={viewModel.api.cancel}
          >
            {t('btn.cancel')}
          </Button>

          <Button
            onClick={viewModel.api.submit}
            loading={viewModel.data.saving}
          >
            {t('btn.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
